module.exports = __webpack_public_path__ + "img/delete.122483af.svg";